// Ετικέτα δικαστή στα dropdown ανάθεσης: όνομα · βαθμός · «Χ/100» (πλήθος υποθέσεων τρέχοντος έτους / όριο)
export const JudgeLoadBadge = ({ judge, className = "" }) => {
  if (judge?.case_count == null || judge?.case_limit == null) return null;
  const full = judge.case_count >= judge.case_limit;
  const near = !full && judge.case_count >= judge.case_limit * 0.9;
  const cls = full ? "bg-red-100 text-red-800 border-red-300" : near ? "bg-amber-100 text-amber-800 border-amber-300" : "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span className={`ml-1 inline-flex items-center rounded border px-1 text-[10px] font-mono leading-4 ${cls} ${className}`}
          title={`${judge.case_count} από ${judge.case_limit} υποθέσεις (έτος ΓΑΚ ${judge.count_year || ""}) — όλοι οι τύποι/καταστήματα`}
          data-testid={`judge-load-${judge.id || judge.full_name}`}>
      {judge.case_count}/{judge.case_limit}
    </span>
  );
};

export const JudgeOptionLabel = ({ judge, showEmail = false }) => (
  <span className="inline-flex items-center flex-wrap gap-x-1">
    <span className="font-medium">{judge.full_name || judge.username}</span>
    {judge.grade && <span className="text-slate-600 text-xs">— {judge.grade}</span>}
    {showEmail && judge.email && <span className="text-slate-500 text-xs">({judge.email})</span>}
    {judge.active === false && <span className="text-red-500 text-[10px]">(ανενεργός)</span>}
    <JudgeLoadBadge judge={judge} />
  </span>
);

export default JudgeOptionLabel;
